var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArc20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 302",
    d: "M2.5 5.125L10 11.375",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630573",
    x: 8.125,
    y: 9.5,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 67",
    d: "M18.75 6.577C17.9665 4.84109 16.8062 3.34927 15.3737 2.23625C13.9412 1.12322 12.2817 0.424029 10.545 0.201812C8.80835 -0.0204045 7.0492 0.241348 5.4264 0.963435C3.80361 1.68552 2.36827 2.84521 1.25 4.33777L2.8681 5.83362C3.76272 4.63957 4.91098 3.71182 6.20922 3.13415C7.50746 2.55648 8.91478 2.34708 10.3041 2.52485C11.6934 2.70263 13.021 3.26198 14.167 4.1524C15.313 5.04282 16.2413 6.23627 16.8681 7.625L18.75 6.577Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630574",
    x: 15.625,
    y: 5.75,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630575",
    x: 0.625,
    y: 3.25,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArc20);
export default __webpack_public_path__ + "static/media/arc_20.77c6c7f49c957840b98790d0f58422f3.svg";
export { ForwardRef as ReactComponent };